import React from "react";
import { Box, Button, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/EmailOutlined";

import { formatCurrency } from "@APP/utils";
import { ReusableRtpPayerResponse } from "@APP/types";

interface Props {
  reusableRtpData: ReusableRtpPayerResponse;
  /**
   * TODO(Q2): Wire in once decode response company info source is confirmed.
   * Falls back gracefully when undefined.
   */
  companyName?: string;
  companyEmail?: string;
}

const ReusableRTPSummary: React.FC<Props> = ({ reusableRtpData, companyName, companyEmail }) => {
  const { description, reference, paymentDetails } = reusableRtpData;
  const isVariableAmount = parseFloat(paymentDetails.amount.amount) === 0;

  return (
    <Box textAlign="center" id="reusableRtpSummaryBox">
      {companyName && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography id="reusableRtpSummaryCompanyLabel">
            <b>{companyName}</b> has requested
          </Typography>
        </Box>
      )}

      {!isVariableAmount && (
        <Box my={0.5}>
          <Typography
            color="textSecondary"
            component="p"
            variant="h4"
            id="reusableRtpSummaryAmount">
            {formatCurrency(paymentDetails.amount)}
          </Typography>
        </Box>
      )}

      {reference && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography gutterBottom id="reusableRtpSummaryForLabel">
            For&nbsp;
          </Typography>
          <Typography component="p" variant="subtitle1" gutterBottom id="reusableRtpSummaryRef">
            {reference}
          </Typography>
        </Box>
      )}

      {description && (
        <Box display="flex" alignItems="center" justifyContent="center" mt={1}>
          <Typography
            component="p"
            variant="body2"
            color="textSecondary"
            id="reusableRtpSummaryDescription"
            sx={{ maxWidth: 550, textAlign: "center" }}>
            {description}
          </Typography>
        </Box>
      )}

      {companyName && (
        <Box display="flex" flexDirection="column" alignItems="center" mt={2} mb={2}>
          <Button
            size="small"
            {...(companyEmail
              ? { href: `mailto:${companyEmail}`, target: "_blank", rel: "noopener noreferrer" }
              : {})}
            id="reusableRtpSummaryContactButton"
            startIcon={<EmailIcon />}>
            Contact {companyName}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ReusableRTPSummary;
